/****************************************************
 * Module Name:  uploadProcessMediaModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import Modal from "react-bootstrap/Modal";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import { IoIosAddCircleOutline } from "react-icons/io";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Select from "react-select";
import ProcessProxy from "../../utility/proxy/manager/processProxy"

const UploadProcessMediaModal = ({
    show,
    loader,
    handleSave,
    handleClose,
    sourceData, mediaType
}) => {
    const [selectedMedia, setSelectedMedia] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState({});
    const [processOptions, setProcessOptions] = useState([]);

    useEffect(() => {
        fetchProcessMasterBySequence();
    }, [])

    const fetchProcessMasterBySequence = () => {
        ProcessProxy.GetAllProcessBySequence(
            (responseData) => {
                if (responseData) {
                    let processes = [];
                    responseData.forEach(iData => {
                        processes.push({ value: iData.id, label: iData.fullname })
                    })
                    setProcessOptions(processes);
                }
            }
        )
    };

    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files) {
            const mediaArray = Array.from(files).map((file) => URL.createObjectURL(file));
            setSelectedMedia((prevMedia) => [...prevMedia, ...mediaArray]);
            setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
        }
    };

    const handleRemoveMedia = (index) => {
        setSelectedMedia((prevMedia) => prevMedia.filter((_, i) => i !== index));
        setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        let data = new FormData();
        selectedFiles.forEach((file) => {
            data.append("files", file);
        });
        handleSave(data, sourceData.kapanid, sourceData.packetid, selectedProcess.value)
    };

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                enforceFocus={false}
                backdrop="static"
                keyboard={true}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Upload Process {mediaType}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ height: '400px', overflowY: 'auto', paddingBottom: '50px' }}>
                    <Box sx={{
                        paddingTop: "10px",
                        "& .MuiOutlinedInput-input": {
                            padding: "9px !important"
                        },
                        "& .MuiInputLabel-root": {
                            top: "-7px !important"
                        }
                    }}>
                        <div style={{ position: "relative", padding: "20px" }}>
                            <Box sx={{ display: "flex", width: "100%", alignItems: "center", gap: "8px" }}>


                                <Box sx={{ display: "flex", width: "35%", gap: "8px" }}>
                                    <Box sx={{ width: "50%", }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>Kapan Id :  {sourceData.kapanid}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ width: "50%", }}>
                                        <Typography sx={{ fontWeight: 'bold' }}>Packet Id :  {sourceData.packetid}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ width: "35%", display: "flex", marginRight: "15px", gap: "8px" }}>
                                    <Box sx={{ width: "30%", marginTop: "7px" }}>
                                        <Typography >Process:</Typography>
                                    </Box>
                                    <Box sx={{ width: "70%", }}>
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            menuPortalTarget={document.body}
                                            styles={Constants.Styles}
                                            options={processOptions}
                                            value={selectedProcess}
                                            isSearchable={false}
                                            onChange={(e) => setSelectedProcess(e)}
                                        />
                                    </Box>
                                </Box>

                                <Box sx={{ width: "30%" }}>
                                    <Button
                                        component="label"
                                        variant="contained"
                                        size="small"
                                        startIcon={<IoIosAddCircleOutline size={20} />}
                                        disabled={Object.keys(selectedProcess).length === 0}
                                        onClick={() => document.getElementById("fileInput").click()}
                                    >
                                        ADD {mediaType}
                                    </Button>
                                </Box>

                                <input
                                    id="fileInput"
                                    type="file"
                                    multiple
                                    accept={mediaType === "image" ? "image/*" : "video/mp4"}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />

                            </Box>
                            <div
                                style={{
                                    marginTop: "25px",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "10px",
                                    overflowY: "auto",
                                }}
                            >
                                {selectedMedia.length === 0 ? (
                                    <div style={{ textAlign: "center", marginTop: "130px", color: "black", marginLeft: "240px" }}>
                                        <p>No {mediaType} selected. Add {mediaType}.</p>
                                    </div>
                                ) : (
                                    <div style={{ display: "flex", flexWrap: "wrap", marginTop: "25px" }}>
                                        {selectedMedia.map((media, index) => (
                                            <div key={index} style={{ margin: "10px", position: "relative" }}>
                                                {/* Media Display */}

                                                {mediaType === "image" ? (<img
                                                    src={media}
                                                    alt={`selected-img-${index}`}
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "cover",
                                                        border: "2px solid #ddd",
                                                        borderRadius: "8px",
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                        transition: "transform 0.2s, box-shadow 0.2s",
                                                    }}

                                                />) :
                                                    (<video
                                                        src={media}
                                                        controls
                                                        autoPlay
                                                        loop
                                                        muted
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "cover",
                                                            border: "2px solid #ddd",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                            transition: "transform 0.2s, box-shadow 0.2s",
                                                        }}
                                                    />)}

                                                <HighlightOffIcon style={{
                                                    position: "absolute",
                                                    top: "-10px",
                                                    right: "-10px",
                                                    backgroundColor: "white",
                                                    borderRadius: "60%",
                                                    color: "black",
                                                    cursor: "pointer",
                                                    padding: "0px",
                                                    fontSize: "28px",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                }} size={100}
                                                    onClick={() => handleRemoveMedia(index)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </Box>
                </Modal.Body>

                <Modal.Footer>
                    <Box sx={{
                        "& .Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                            color: "rgba(0, 0, 0, 0.26) !important"
                        }
                    }}>
                        <LoadingButton
                            sx={{ mr: 1 }}
                            variant="contained"
                            color="info"
                            onClick={handleSubmit}
                            loading={loader}
                            loadingPosition="start"
                            startIcon={<AssignmentTurnedInIcon />}
                            type="Submit"
                            disabled={selectedMedia.length === 0}
                        >
                            Submit
                        </LoadingButton>
                    </Box>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        </div >
    );
};

export default UploadProcessMediaModal;